import React from 'react';
import { useTranslation } from 'react-i18next';
import { BasicSelector, MwInputText, MwTextArea } from '../../components/ui';

const SettingListItem = ({
    settingName,
    settingValue,
    filterDefineSetting,
    setGeneralSetting,
    generalSetting,
    currentLangId,
    prefixLang = 'general',
}) => {
    const [t] = useTranslation('settings');
    const definition = filterDefineSetting(settingName);
    const isBooleanSetting = settingValue === 'true' || settingValue === 'false';

    const getValue = (name, value) => {
        return (
            filterDefineSetting(name)
                ?.valueTypeList?.find(
                    (item) => item.value === value && item.lang === currentLangId
                )?.label || value
        );
    };

    const handleList = (name) => {
        const generatedList =
            filterDefineSetting(name)?.valueTypeList?.filter(
                (item) => item.lang === currentLangId
            ) || [];

        return generatedList.map((item) => ({
            label: item.label,
            value: { [name]: item.value },
        }));
    };

    const onSelected = (item) => {
        setGeneralSetting({ ...generalSetting, ...item.value });
    };

    const renderSelector = (label, listItem) => (
        <BasicSelector
            label={label}
            listItem={listItem}
            onSelected={onSelected}
            className='w-full px-0'
            buttonClassName='w-full justify-between bg-white text-[#251658] hover:text-[#251658]'
        />
    );

    const renderControl = () => {
        if (isBooleanSetting) {
            return renderSelector(t(`${prefixLang}.${settingValue.toUpperCase()}`), [
                { label: t(`${prefixLang}.TRUE`), value: { [settingName]: 'true' } },
                { label: t(`${prefixLang}.FALSE`), value: { [settingName]: 'false' } },
            ]);
        }

        if (definition?.valueType === 'list') {
            return renderSelector(getValue(settingName, settingValue), handleList(settingName));
        }

        if (definition?.valueType === 'textArea') {
            return (
                <MwTextArea
                    value={settingValue}
                    rows={4}
                    onChange={(e) =>
                        setGeneralSetting({ ...generalSetting, [settingName]: e.target.value })
                    }
                />
            );
        }

        return (
            <MwInputText
                value={settingValue}
                classNameInput='bg-white text-start'
                onChange={(e) =>
                    setGeneralSetting({ ...generalSetting, [settingName]: e.target.value })
                }
            />
        );
    };

    return (
        <div className='grid gap-3  border border-slate-200 bg-slate-50 p-3 md:grid-cols-[220px,1fr] md:items-center'>
            <div className='text-sm font-medium text-[#251658]'>{t(`${prefixLang}.${settingName}`)}</div>
            <div>{renderControl()}</div>
        </div>
    );
};

export default SettingListItem;
